import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row className="my-5">
          <Col md={8} className="home-about-description text-light">
            <h1
              style={{
                fontSize: "2.2em",
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              ALLOW ME TO <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p
              className="home-about-body"
              style={{ fontSize: "1.3em", lineHeight: "1.8", color: "#f0f0f0" }}
            >
              I’m <b className="purple">Ripudaman</b>, a passionate{" "}
              <b className="purple">Full-Stack Developer</b> based in Jaipur.
              With hands-on experience in building scalable and high-performance
              web apps, I specialize in{" "}
              <b className="purple">MERN Stack, Nest.js,</b> and recently,{" "}
              <b className="purple">Node.js with Sequelize ORM</b>.
              <br />
              <br />I love crafting clean, secure, and production-ready code
              that solves real-world problems. I’ve worked on CRM systems, field
              service tools, and beneficiary management systems using
              <i>
                <b className="purple">
                  {" "}
                  Node.js, React.js, Sequelize, and MongoDB.{" "}
                </b>
              </i>
              <br />
              <br />
              I'm also experienced in developing REST APIs, managing user
              authentication with
              <b className="purple"> JWT & middleware</b>, and designing secure
              and responsive frontends with
              <b className="purple"> reusable components and Context API.</b>
              <br />
              <br />
              Currently working at <b className="purple">Pizone Infotech</b>, I
              enjoy collaborating with QA teams, designers, and stakeholders to
              deliver high-quality solutions.
              <br />
              <br />
              Aside from coding, I’m exploring areas like{" "}
              <b className="purple">Cloud, DevOps, Automation, and AI/ML</b>.
            </p>
          </Col>

          <Col
            md={4}
            className="myAvtar d-flex justify-content-center align-items-center"
          >
            <Tilt>
              <img
                src={myImg}
                className="img-fluid rounded-circle shadow-lg"
                alt="avatar"
                style={{ border: "5px solid #6f42c1", maxWidth: "80%" }}
              />
            </Tilt>
          </Col>
        </Row>

        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/ripu1821"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/ripu1547507"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/ripu-daman-66947a27b/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/ripu_bishnoi_18"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
